/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { consumeDependency } from '@jira/router-resources__utils/src/consumeDependency.tsx';
import type { ResourceDependencies } from '@atlassian/react-resource-router/src/common/types';

export const getDependencyData = <T,>(
	dependencies: ResourceDependencies,
	key: string,
): T | Promise<T> => {
	if (dependencies[key]?.loading || dependencies[key]?.error) {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		return consumeDependency(dependencies, key) as Promise<T>;
	}
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return dependencies[key]?.data as T;
};
